import { FC, PropsWithChildren } from 'react';

export const CustomSlotSection: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className="flex-1" data-testid="navigation_custom_slot">
      {children && <div className="flex h-10 items-center justify-center stihl-text-body-xs-bold">{children}</div>}
    </div>
  );
};
